

type FilterPluginspaceDto = {
    search?: string
    status?: { label: string; value: number }
    type?: { label: string; value: string }
}

type FilterPluginspace = {
    status?: boolean
    type?: string
}

type TableParams = {
    page?: number
    pageSize?: number
    search?: string
    sorting?: { field: string; direction: 'asc' | 'desc' }
    filters?: FilterPluginspaceDto
}

type PluginSpace = {
    id: number
    name: string
    type: string
    subdomain: string
    status: string
    active: boolean
    created: Date
    cnpj: string
}



type FilterUserDto = {
    search?: string
    status?: { label: string; value: number }
    type?: { label: string; value: string }
}

export type { FilterPluginspace, FilterUserDto, FilterPluginspaceDto, TableParams, PluginSpace, }

enum SegmentType {
    fashion = 'fashion',
    general = 'general',
    food = 'food',
    varejo = 'varejo',
    hotel = 'hospitality',
}

type Feature = {
    id: number
    name: string
    code?: string
    description: string
    segmentType: SegmentType
    pageId?: number
}

type PluginspaceFeature = {
    id: number
    pluginspaceId: number
    featureId: number
    feature: Feature
}

type CreateFeatureDto = {
    name: string
    code: string
    description: string
    segmentType: SegmentType
    pageId?: number
}

type UpdateFeatureDto  = CreateFeatureDto

type ResponseCreateUpdate = {
    message: string
    success: boolean
    data?: Feature
    typemsg?: 'success' | 'error' | 'warning'
}

type Pages = {
icon: string
id: number
menu: number
name: string
newIcon: string | null
order: number
parent: number
route: string
type: string | null
}

export { SegmentType }
export type { Feature, PluginspaceFeature , UpdateFeatureDto , CreateFeatureDto,ResponseCreateUpdate, Pages }